import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { MiniFlexTable } from "@similarweb/ui-components";

export const StyledTable = styled(MiniFlexTable)`
    &.MiniFlexTable {
        padding-bottom: 0;
        flex: 1;
    }

    .MiniFlexTable-cell {
        height: 40px;
        vertical-align: middle;
        font-size: 14px;
        &:not(:first-child) {
            border-top: 1px solid ${colorsPalettes.carbon[50]};
        }
    }

    .MiniFlexTable-column {
        &:first-of-type {
            .MiniFlexTable-headerCell,
            .MiniFlexTable-cell {
                padding-left: 24px;
            }
        }

        &:last-of-type {
            .MiniFlexTable-headerCell,
            .MiniFlexTable-cell {
                padding-right: 24px;
            }
        }

        .MiniFlexTable-cell {
            > div {
                height: 100%;
                align-items: center;
                display: flex;
            }
        }
    }
    .MiniFlexTable-headerCell {
        margin-bottom: 2px;
        padding: 8px 0 8px 0;
        font-weight: 500;
        font-size: 12px;
        color: ${setFontVariant("captionTitle", colorsPalettes.carbon[300])};
    }
`;
